export var normalizeFontFamilyName = function (fontFamilyName) {
    return fontFamilyName
        .toLowerCase()
        .trim()
        .replace(/"/g, '')
        .replace(/\s/g, '-')
        .replace(/'/g, '');
};
//# sourceMappingURL=normalize-font-family-name.js.map